import { FC, HTMLAttributes, ReactNode } from 'react';
import clx from 'classnames';
import { Avatar } from 'src/Components';
import { Headline } from 'src/UI';
import CertificateInfo from './CertificateInfo';
import { SignerCertInfoType } from 'src/Types/File/Attachment';
import DateFormater from 'src/Utils/DateFormater';
import st from './SignInfo.module.scss';

interface ISignInfoProps extends HTMLAttributes<HTMLDivElement> {
	id: string;
	userName?: string;
	userOrg?: string;
	avatar?: string | null;
	gender?: 'female' | 'male';
	status: number;
	signDate?: string;
	signCertificateInfo?: SignerCertInfoType;
	downloadCertLink?: string;
}

const SignInfo: FC<ISignInfoProps> = (props) => {
	const {
		id,
		status,
		userName = '',
		userOrg = '',
		avatar = '',
		signDate,
		signCertificateInfo,
		downloadCertLink,
		gender,
		className,
		...otherProps
	} = props;

	if ('downloadCertLink' in otherProps) {
		delete (otherProps as Partial<ISignInfoProps>).downloadCertLink;
	}

	const renderStatus = () => {
		let statusInfo: { text: string; className: string } | null = null;

		switch (status) {
			case 1: // Valid
				statusInfo = { text: 'Получена', className: st.valid };
				break;
			case 2: // Waiting
				statusInfo = { text: 'Запрошена', className: st.requested };
				break;
			case 0: // Error
				statusInfo = { text: 'С ошибкой', className: st.error };
				break;
			default:
				break;
		}

		if (!statusInfo) {
			return null;
		}

		return (
			<span
				className={clx('body-small', st.status, statusInfo.className)}
			>
				{statusInfo.text}
			</span>
		);
	};

	const renderContent = () => {
		if (signCertificateInfo) {
			return (
				<span className={clx('body-xsmall', st.truncate)}>
					{signCertificateInfo?.subjUserName}
					&ensp;|&ensp;
					{signDate || null}
				</span>
			);
		} else {
			return (
				<span className={clx('body-xsmall', st.truncate)}>
					{userOrg}
				</span>
			);
		}
	};

	return (
		<div className={clx(st.block, className)} {...otherProps}>
			<div className={st.statusWrapper}>
				<CertificateInfo
					targetId={id}
					status={status}
					info={signCertificateInfo}
					downloadCertLink={downloadCertLink}
				/>
				{renderStatus()}
			</div>
			<Avatar avatarUrl={avatar} title="Аватар пользователя" size={38} />
			<div className={st.textBlock}>
				<Headline type="small" className={st.truncate}>
					{userName}
				</Headline>
				{renderContent()}
			</div>
		</div>
	);
};

export default SignInfo;
